/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsersettingUe } from '../../models/usersetting-ue';

export interface GetUserSetting$Params {
  orid: number;
  usid: number;
}

export function getUserSetting(http: HttpClient, rootUrl: string, params: GetUserSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersettingUe>> {
  const rb = new RequestBuilder(rootUrl, getUserSetting.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
    rb.path('usid', params.usid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsersettingUe>;
    })
  );
}

getUserSetting.PATH = '/getusersettingdetail/{orid}/{usid}';
